import { __assign } from "tslib";
import update from 'immutability-helper';
import { GET_COMPANY_USERS } from '..';
export default function cacheUpdateCompanyMembers(cache, _a, updateFn) {
    var teamPk = _a.teamPk, emails = _a.emails;
    var queryProps = {
        query: GET_COMPANY_USERS,
        variables: {
            teamPk: teamPk,
        },
    };
    var data = cache.readQuery(queryProps);
    var updatedData = emails.reduce(function (acc, email) {
        var _a;
        var memberEdgeIndex = data.user.company.members.edges.findIndex(function (edge) { return edge.node.email === email; });
        return memberEdgeIndex === -1
            ? acc
            : update(acc, {
                user: {
                    company: {
                        members: {
                            edges: (_a = {},
                                _a[memberEdgeIndex] = {
                                    $apply: updateFn,
                                },
                                _a),
                        },
                    },
                },
            });
    }, data);
    cache.writeQuery(__assign(__assign({}, queryProps), { data: updatedData }));
}
